import { type QueryClient } from '@tanstack/react-query';
import { type RouteObject } from 'react-router-dom';

import { requirePermissions } from '@/app/requirePermissions';
import { PagePermissions } from '@/models/pagePermissions';

export const seasonPassRoute = (queryClient: QueryClient): RouteObject => ({
  path: 'season-passes',
  // On the parent, so the child keeps its own data loader untouched.
  loader: requirePermissions({ oneOf: PagePermissions.seasonPasses }),
  children: [
    {
      index: true,
      lazy: async () => {
        const { loader, Component } = await import('./seasonPasses');
        return { loader: loader(queryClient), Component };
      },
    },
  ],
});
